<div class="workflow-applications-main-container">
  <div class="search-panel-container">
    <div class="top-container">
      <app-common-filterbuilder-staff-janus [placeholder]="placeholder" [showAdvancedFilter]="showAdvancedFilter"
        (search)="onSearch($event)" (attributeSelect)="onAttribute($event)" (bulkSelect)="onBulk($event)"
        (parcelId)="handleParcelIdChange($event)" (propertyOwner)="handlePropertyOwnerChange($event)"
        (propertyAddress)="handlePropertyAddressChange($event)" [attributeOptions]="applicationAttributes"
        [myWorkOptions]="myWorkOptions" (filterChanged)="onFilterChanged($event)" [useMuiLayout]="true"
        [externalFilterInputs]="filterInputs"
        (externalFilterInputsChange)="onExternalFiltersChanged($event)"
        [local_storage_key]="FILTER_CACHE_KEY"
        [allowTransformFilterValue]="false"
        [customTemplate]="BulkButtonTemplate" >
      </app-common-filterbuilder-staff-janus>
      <!-- <div class="bulk-actions-container" *ngIf="bulkActions?.length">



          <div class="bulk-wrapper">
            <button class="blue-btn" (click)="toggleBulk()" [disabled]="!selected?.length">
              <mat-icon>content_copy</mat-icon>
              <span>BULK</span>
              <mat-icon class="arrow">keyboard_arrow_down</mat-icon>
            </button>


            <div class="bulk-dropdown" *ngIf="isBulkOpen">
              <div
                class="bulk-item"
                *ngFor="let action of bulkActions"
                (click)="onBulkActionClick(action); closeBulk()"
              >
                {{ action.name }}
              </div>
            </div>
          </div>

        </div> -->
      <ng-template #BulkButtonTemplate>
        <div class="bulk-actions-container" *ngIf="bulkActions?.length">
          <!-- BULK BUTTON -->
          <!-- <div class="blue-btn clickable" [class.disabled]="!selected?.length" [matMenuTriggerFor]="bulkMenu" (menuOpened)="styleBulkMenu()"> -->

           <div
  class="blue-btn clickable"
  [class.disabled]="!selected?.length"
  [matMenuTriggerFor]="!isMobileView ? bulkMenu : null"
  (click)="isMobileView ? openBulkDrawer() : styleBulkMenu()"
>
 <mat-icon class="dropdown-icon">content_copy</mat-icon>
            <span>BULK</span>
            <mat-icon class="arrow dropdown-icon">keyboard_arrow_down</mat-icon>
          </div>

          <!-- BULK MENU -->
          <mat-menu #bulkMenu="matMenu" panelClass="bulk-menu-panel"   yPosition="below" xPosition="after">
            <button mat-menu-item *ngFor="let action of bulkActions" (click)="onBulkActionClick(action)"
              [disabled]="!selected?.length">
              {{ action.name }}
            </button>
          </mat-menu>
        </div>
      </ng-template>
      <!-- MOBILE BULK DRAWER -->
<div
  *ngIf="isBulkDrawerOpen"
  class="mobile-drawer-overlay"
  (click)="closeBulkDrawer()"
>

  <div
    class="mobile-drawer-card"
    (click)="$event.stopPropagation()"
  >

    <div class="mobile-drawer-header">

      <div class="mobile-drawer-title">
        Bulk
      </div>

      <div
        class="mobile-drawer-close"
        (click)="closeBulkDrawer()"
      >
        <mat-icon>close</mat-icon>
      </div>

    </div>

    <div class="mobile-drawer-body">

      <div
        class="mobile-drawer-item"
        *ngFor="let action of bulkActions"
        (click)="onBulkActionClick(action); closeBulkDrawer()"
      >
        {{ action.name }}
      </div>

    </div>

  </div>

</div>
    </div>
    <!-- @if (filterInputs.length > 0) {
    <div class="filter-chip-container">
      @for (item of filterInputs; track $index) {
      <div class="filter-chip">
        <wm-common-text [data]="{ text: item.title }"></wm-common-text>
        <div class="filter-details">
          <wm-common-text
            [data]="{ text: item.options[0].filterText }"
          ></wm-common-text>
          <wm-common-text
            [data]="{ text: item.options[0].searchOptionMethod }"
          ></wm-common-text>
          <wm-common-text
            [data]="{ text: item.options[0].searchText }"
          ></wm-common-text>
          <div
            class="filter-chip-remove-icon"
            (click)="onFilterChipRemoveIconClick($index)"
          >
            <wm-common-icon [data]="{ iconName: 'close' }"></wm-common-icon>
          </div>
        </div>
      </div>
      }
    </div>
    }  -->
  </div>
  <ng-template #dataMapParcelsTabs>
  <div class="data-and-map-container">

    <div
      class="data-table-tab-button-container"
      [routerLink]="['data']"
      routerLinkActive="active-tab"
      routerLinkActiveOptions="{ exact: true }">

      <wm-common-button
        [data]="onTabButtonClick('DATA', 'data')">
      </wm-common-button>
    </div>

    <div
      class="map-tab-button-container"
      [routerLink]="['map']"
      routerLinkActive="active-tab"
      routerLinkActiveOptions="{ exact: true }">

      <wm-common-button
        [data]="onTabButtonClick('MAP', 'map')">
      </wm-common-button>
    </div>

    <div
      class="parcels-tab-button-container"
      [routerLink]="['parcels']"
      routerLinkActive="active-tab"
      routerLinkActiveOptions="{ exact: true }">

      <wm-common-button
        [data]="onTabButtonClick('PARCELS', 'parcels')">
      </wm-common-button>
    </div>

  </div>
</ng-template>
  <div class="body-container">
    <div class="body-type-container"   [class.hide-body-type-container]="!isDataRoute"
>
      <div class="desktop-view ">
      <ng-container *ngTemplateOutlet="dataMapParcelsTabs"></ng-container>
</div>
      @if (isDataRoute) {
      <!-- Added by Amisha on 2026-07-29.
           Reason: disable Start New Application while a start request is already in progress. -->
      <div class="new-application-tab-container" [ngClass]="{
          'active-new-application':
            workflowApplicationsJanusDetails.activeNewApplicationId || isLoading
        }">
        @if (workflowApplicationsJanusDetails.activeNewApplicationId || isLoading) {
        <wm-common-text [data]="{ text: 'Start New Application' }"></wm-common-text>
        }@else {
        <wm-common-text [matMenuTriggerFor]="newApplicationsMatMenu"
          [data]="{ text: 'Start New Application' }"></wm-common-text>
        }

        <mat-menu #newApplicationsMatMenu="matMenu" xPosition="before" yPosition="below">
          <div class="new-applications-menu-card" [ngClass]="{
              'scrollable-new-applications-menu-card':
                workflowApplicationsJanusDetails.newApplications.length > 4
            }">
            @if (workflowApplicationsJanusDetails.errorNewApplicationFetch) {
            <wm-common-text [data]="{
                text: workflowApplicationsJanusDetails.errorNewApplicationFetch
              }"></wm-common-text>
            }@else { @if
            (workflowApplicationsJanusDetails.isNewApplicationFetching ===
            false) {
              @if(workflowApplicationsJanusDetails.newApplications.length > 4){
                <div (click)="$event.stopPropagation()" >
            <wm-common-textfield [data]="searchFieldConfig" [(ngModel)]="searchQuery"
              (ngModelChange)="handleSearchChange($event)">
            </wm-common-textfield>
            </div>
              }
            @for (application of
            workflowApplicationsJanusDetails.displayNewApplications; track $index) {
            <div [ngClass]="{
                'active-new-application':
                  application.value ===
                  workflowApplicationsJanusDetails.activeNewApplicationId
              }">
              <wm-common-button [data]="
                  onNewApplicationMenuItemClick(
                    application.name,
                    application.value
                  )
                "></wm-common-button>
            </div>
            } }@else {
            <mat-progress-spinner mode="indeterminate" diameter="48">
            </mat-progress-spinner>
            } }
          </div>
        </mat-menu>
      </div>
      }@else {
      <div></div>
      }
    </div>
    <div class="mobile-view">
          <ng-container *ngTemplateOutlet="dataMapParcelsTabs"></ng-container>
</div>
    <!-- Added by Amisha on 2026-07-29.
         Reason: render blocking table loading and dismissible error overlays for the full start-application flow. -->
    <div class="inner-body-container" [class.start-application-loading]="isLoading"
      [attr.aria-busy]="isLoading">
      <router-outlet></router-outlet>
      @if (isLoading) {
      <div class="start-application-loading-overlay" role="status" aria-label="Starting new application">
        <mat-progress-spinner mode="indeterminate" diameter="48"></mat-progress-spinner>
      </div>
      }
      @if (startApplicationError) {
      <div class="start-application-error-overlay" role="alert">
        <div class="start-application-error-card">
          <button type="button" class="start-application-error-close"
            aria-label="Dismiss start application error"
            (click)="dismissStartApplicationError()">
            <mat-icon>close</mat-icon>
          </button>
          <wm-common-icon class="start-application-error-icon"
            [data]="{ iconName: errorIcon }">
          </wm-common-icon>
          <div class="start-application-error-message">
            <div class="start-application-error-label">Error</div>
            <div>Some error occurred.</div>
            <div>Please try again later.</div>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</div>
<wm-modal-confirm [showButton]="false" moduleId="currentActivitiesConfirmJanus"
  [title]="bulkActionText + ' ' + selected?.length + ' Application(s)'"
  [commandText]="bulkActionText + ' ' + selected?.length + ' Application(s)'"
  (accepted)="bulkCloseApplications(selected)" [janusStyling]="true" [isJanusMobileview]="true" (canceled)="resetBulkSelection()"
  janusModalWidth="600px" [enabled]="true" [form]="bulkActionForm" [closeOnAccept]="false" #bulkActionConfirm>
  <div [formGroup]="bulkActionForm">
    <div class="row">
      <div class="col">
        <label for="bulkActionReason">{{ bulkActionText }} Reason</label>
        <!-- <textarea
          style="height:100px"
          id="bulkActionReason"
          name="bulkActionReason"
          class="form-control mx-2"
          formControlName="bulkActionReason"
          [placeholder]="bulkActionText + ' Reason'"
          [attr.aria-label]="bulkActionText + ' Reason'"
        >
        </textarea> -->
        <wm-common-textfield class="mx-2" formControlName="bulkActionReason" [data]="{
            type: 'text-area',
            id: 'bulkActionReason',
            label: bulkActionText + ' Reason',
            placeholder: bulkActionText + ' Reason',
            textAreaRows: 4,
            required: true
          }">
        </wm-common-textfield>
        <div *ngIf="bulkActionReason?.untouched" class="text-danger">
          * {{ bulkActionText }} Reason is required.
        </div>
        <div *ngIf="
            bulkActionReason?.invalid &&
            (bulkActionReason?.dirty || bulkActionReason?.touched)
          " class="alert alert-danger">
          <div *ngIf="bulkActionReason.errors['required']" class="text-danger">
            * {{ bulkActionText }} Reason is required. *
          </div>
        </div>
      </div>
    </div>
    <!-- Start Code added by Sanchit on 19/05/2026 -->
    <!-- <div class="row">
      <div class="col">
        <label for="bulkActionDateTime" class="mt-2">
          Time
          <input id="bulkActionDateTime" name="bulkActionDateTime" class="form-control mt-2"
            formControlName="bulkActionDateTime" placeholder="" aria-label="DateTime" />
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="mt-2">
          Changed By
          <input name="bulkActionUser" class="form-control mt-2" formControlName="bulkActionUser" placeholder=""
            aria-label="BulkActionUser" />
        </label>
      </div>
    </div> -->
    <div class="bulk-textfield-row">
      <wm-common-textfield
        class="bulk-textfield-item"
        [data]="{
          label: 'Time',
          placeholder: '',
          type: 'text'
        }"
        formControlName="bulkActionDateTime">
      </wm-common-textfield>

      <wm-common-textfield
        class="bulk-textfield-item"
        [data]="{
          label: 'Changed By',
          placeholder: '',
          type: 'text'
        }"
        formControlName="bulkActionUser">
      </wm-common-textfield>
    </div>
    <!-- End Code added by Sanchit on 19/05/2026 -->
  </div>

  <p>
    Any inspections currently in progress in these applications will be marked
    as Voided, and will not be visible by default in inspection searches.
  </p>

  <p>
    Are you sure you want to {{ bulkActionText.toLowerCase() }}
    <b>{{ selected?.length }} application(s)</b>?
  </p>
</wm-modal-confirm>
